module.exports = __webpack_public_path__ + "img/59.fb300f99.jpg";